import { FilterType } from '@/types/asset-search.types';
import ListView, { ListViewItem } from '@ingka/list-view';
import { translate } from '@repo/phrase';

import { useSearch } from '@/components/filters/search/search.hooks';

import { getAppConfig } from '@/utils/window.utils';

export const DaysFilter = () => {
    const { addFilter, daysFilter } = useSearch();
    const options = getAppConfig().filters.noOfDays.options;

    return (
        <ListView id="day-filter" data-testid="day-filter" size="small">
            {options.map((option) => {
                return (
                    <ListViewItem
                        inset
                        key={option}
                        title={translate(`filter_days_${option}`)}
                        control="radiobutton"
                        name="days-filter"
                        onChange={(e) => {
                            // oxlint-disable-next-line @typescript-eslint/consistent-type-assertions
                            (e.target as HTMLInputElement).checked && addFilter(FilterType.NoOfDays, option);
                        }}
                        controlProps={{
                            value: option,
                            checked: daysFilter === option,
                        }}
                    />
                );
            })}
        </ListView>
    );
};
